import {
  TrackImpressionDirective,
  TrackLinkDirective,
} from '@analytics/events';
import { Component, Input } from '@angular/core';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ComponentFields, JssModule } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-aom-footer',
  templateUrl: './aom-footer.component.html',
  styleUrls: ['./aom-footer.component.essent.scss'],
  standalone: true,
  imports: [
    TrackLinkDirective,
    AutomationIdDirective,
    JssModule,
    TrackImpressionDirective,
  ],
})
export class AomFooterComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() orderPageUrl?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fields?: ComponentFields;

  constructor(private readonly activeModal: NgbActiveModal) {}

  submitSelectedProposition() {
    this.activeModal.close({ submit: true });
  }
}
